<ic-ui-card class="small-header">
	<header>
		<pv-title>
			<ic-fa-icon icon="line-chart" />
			<h1>{{ "residents.medical.katz" | translate }}</h1>
		</pv-title>
	</header>
	<section>
		<ic-katz-form-card #katzForm [dementia]="isDemented" [katz]="katz" (confirm)="emit($event)" />
	</section>
	<footer>
		<ui-double-button icon="fa fa-save" type="primary" [icValidateForms]="[katzForm.form]" (action)="katzForm.save()">
			{{ "katz.actions.save" | translate }}
		</ui-double-button>
		<ui-double-button icon="fa fa-times" type="secondary" (action)="katzForm.confirm.emit()">
			{{ "katz.actions.cancel" | translate }}
		</ui-double-button>
	</footer>
</ic-ui-card>
